import React from "react";
import { scrollToSection } from "@/lib/scroll";

const FinalCTA = () => {
  return (
    <section
      id="final-cta"
      data-testid="final-cta-section"
      style={{
        position: "relative",
        padding: "96px 0 144px",
        background: "rgba(8,8,8,0.70)",
        overflow: "hidden",
      }}
    >
      {/* Ambient gold */}
      <div style={{ position: "absolute", inset: 0 }}>
        <div style={{ position: "absolute", top: 0, left: 0, right: 0, height: "1px", background: "linear-gradient(90deg, transparent, rgba(210,170,60,0.15), transparent)" }} />
        <div
          style={{
            position: "absolute",
            top: "-160px",
            left: "50%",
            transform: "translateX(-50%)",
            width: "900px",
            height: "900px",
            borderRadius: "50%",
            filter: "blur(200px)",
            background: "radial-gradient(circle, rgba(210,170,60,0.06) 0%, transparent 70%)",
          }}
        />
      </div>

      <div style={{ position: "relative", maxWidth: "900px", margin: "0 auto", padding: "0 24px", textAlign: "center" }}>
        <div
          className="reveal"
          style={{
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "10px",
            letterSpacing: "0.4em",
            color: "rgba(210,170,60,0.8)",
            textTransform: "uppercase",
            marginBottom: "24px",
          }}
        >
          Let's Get Started
        </div>

        <h2
          data-testid="final-cta-headline"
          className="reveal reveal-delay-1"
          style={{
            fontFamily: "'Cormorant Garamond', serif",
            fontSize: "clamp(40px, 6vw, 72px)",
            fontWeight: 300,
            lineHeight: 1.05,
            color: "#fff",
            letterSpacing: "0.02em",
            marginBottom: "32px",
          }}
        >
          Ready to Scale Your{" "}
          <em style={{ color: "#e8c45a", fontStyle: "italic", fontWeight: 400 }}>Operations</em>?
        </h2>

        <p
          className="reveal reveal-delay-2"
          style={{
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "14px",
            fontWeight: 300,
            color: "rgba(220,195,140,0.6)",
            lineHeight: 1.8,
            letterSpacing: "0.02em",
            maxWidth: "480px",
            marginLeft: "auto",
            marginRight: "auto",
            marginBottom: "48px",
          }}
        >
          Let's build your team and start delivering results.
        </p>

        <div
          className="reveal reveal-delay-3"
          style={{
            display: "flex",
            gap: "16px",
            justifyContent: "center",
            flexWrap: "wrap",
          }}
        >
          <button
            data-testid="final-book-button"
            onClick={scrollToSection("#booking")}
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "11px",
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              fontWeight: 400,
              padding: "16px 36px",
              background: "rgba(210,165,40,0.15)",
              border: "1px solid rgba(210,165,40,0.7)",
              color: "#e8c45a",
              cursor: "pointer",
              transition: "all 0.35s",
              borderRadius: "0",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "rgba(210,165,40,0.3)";
              e.currentTarget.style.borderColor = "#e8c45a";
              e.currentTarget.style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "rgba(210,165,40,0.15)";
              e.currentTarget.style.borderColor = "rgba(210,165,40,0.7)";
              e.currentTarget.style.color = "#e8c45a";
            }}
          >
            Book a Call Now
          </button>
          <button
            data-testid="final-contact-button"
            onClick={scrollToSection("#contact")}
            style={{
              fontFamily: "'Montserrat', sans-serif",
              fontSize: "11px",
              letterSpacing: "0.18em",
              textTransform: "uppercase",
              fontWeight: 400,
              padding: "16px 36px",
              background: "transparent",
              border: "1px solid rgba(255,255,255,0.15)",
              color: "rgba(255,255,255,0.65)",
              cursor: "pointer",
              transition: "all 0.35s",
              borderRadius: "0",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "rgba(255,255,255,0.4)";
              e.currentTarget.style.color = "#fff";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "rgba(255,255,255,0.15)";
              e.currentTarget.style.color = "rgba(255,255,255,0.65)";
            }}
          >
            Send a Message
          </button>
        </div>

        <p
          className="reveal reveal-delay-4"
          style={{
            fontFamily: "'Montserrat', sans-serif",
            fontSize: "10px",
            letterSpacing: "0.3em",
            color: "rgba(200,160,50,0.35)",
            textTransform: "uppercase",
            marginTop: "56px",
          }}
        >
          No pressure · No fluff · Just a real conversation
        </p>
      </div>
    </section>
  );
};

export default FinalCTA;
